import { render, staticRenderFns } from "./BettingArea.vue?vue&type=template&id=072fa732&scoped=true&"
import script from "./BettingArea.vue?vue&type=script&lang=js&"
export * from "./BettingArea.vue?vue&type=script&lang=js&"
import style0 from "./BettingArea.vue?vue&type=style&index=0&id=072fa732&scoped=true&lang=css&"
import style1 from "./BettingArea.vue?vue&type=style&index=1&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072fa732",
  null
  
)

export default component.exports